import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18nInstance from './locales/i18n';
import { ThemeProvider } from './context/ThemeContext';
import { DeviceProvider } from './context/DeviceContext';
import 'react-toastify/dist/ReactToastify.css';
import './assets/styles/global.scss';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-modern-drawer/dist/index.css';
import 'swiper/css';
import ReactGA from 'react-ga4';
import config from '@/config';
import { LocaleContextProvider } from './context/LocaleContext';
import { EventDispatcherProvider } from './context/eventDispatcherContext';
import store, { useAppSelector } from './store';
import { authSelector } from '@/store/reducers/auth';
import { NotificationsProvider } from './context/NotificationsContext';
import UserUtils from '@/utils/user';

import AdminSystem from '@/admin/system';
import SchoolSystem from './system';
import { useEffect } from 'react';

if (config.googleAnalyticsId) {
  ReactGA.initialize(config.googleAnalyticsId);
}

const System = () => {
  const { user } = useAppSelector(authSelector);

  const isAdmin = UserUtils.isAdmin(user);
  const isCreateOrgComplete =
    user?.metadata?.organizationDetails?.adminSettings?.isCreateOrgComplete;
  const isAdminWithOrg = isAdmin && isCreateOrgComplete;

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isAdminWithOrg && window.location.pathname.toLowerCase().startsWith('/onboarding')) {
        window.location.replace(window.location.origin);
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [isAdminWithOrg]);

  return isAdminWithOrg ? <AdminSystem /> : <SchoolSystem />;
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <ThemeProvider>
    <EventDispatcherProvider>
      <Provider store={store}>
        <I18nextProvider i18n={i18nInstance}>
          <LocaleContextProvider>
            <DeviceProvider>
              <NotificationsProvider>
                <System />
              </NotificationsProvider>
            </DeviceProvider>
          </LocaleContextProvider>
        </I18nextProvider>
      </Provider>
    </EventDispatcherProvider>
  </ThemeProvider>
);
